import React, { useEffect, useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
} from "react-native";
import ManageApplications from "./manageApplications";
import { HexColorPicker } from "react-colorful";
import { addImage } from "../utils";
import { useRecoilState } from "recoil";
import { tokenState } from "../reducer";

const { width, height } = Dimensions.get("window");

const manageThemes = ({ onPress, items, setItem }) => {
  const [token, setToken] = useRecoilState(tokenState);
  const [page, setpage] = useState(0);
  const [state, setstate] = useState(false);
  const [state1, setstate1] = useState(false);
  const [state2, setstate2] = useState(false);
  const [state3, setstate3] = useState(false);
  const [state4, setstate4] = useState(false);
  const [state5, setstate5] = useState(false);

  console.log("Shool", items);
  // console.log(token);

  function statecolor() {
    if (state) {
      setstate(false);
    } else {
      setstate(true);
      setstate1(false);
      setstate2(false);
      setstate3(false);
      setstate4(false);
      setstate5(false);
    }
  }

  function statecolor1() {
    if (state1) {
      setstate1(false);
    } else {
      setstate(false);
      setstate1(true);
      setstate2(false);
      setstate3(false);
      setstate4(false);
      setstate5(false);
    }
  }

  function statecolor2() {
    if (state2) {
      setstate2(false);
    } else {
      setstate(false);
      setstate1(false);
      setstate2(true);
      setstate3(false);
      setstate4(false);
      setstate5(false);
    }
  }

  function statecolor4() {
    if (state4) {
      setstate4(false);
    } else {
      setstate(false);
      setstate1(false);
      setstate2(false);
      setstate3(false);
      setstate4(true);
      setstate5(false);
    }
  }
  useEffect(() => { }, [items]);

  return (
    <View style={styles.container}>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            alignItems: "center",
            justifyContent: "center",
            marginTop: 80,
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Regular",
              color: "#202020",
            }}
          >
            จัดการธีม
          </Text>

          <View
            style={{
              width: width * 0.8,
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: width * 0.6,
                flexDirection: "row",
                marginVertical: 15,
                height: height * 0.15,
              }}
            >
              <View style={styles.Boxarea}>
                <Text style={[styles.Text20, { width: width * 0.12 }]}>
                  แถบด้านบน
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    statecolor();
                  }}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: items.theme.header,
                      marginHorizontal: 10,
                    },
                  ]}
                />

                {state == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setItem((val) => ({
                        ...val,
                        theme: { ...val.theme, header: text },
                      }));
                    }}
                    color={items.theme.header}
                  />
                )}
                <TextInput
                  onChangeText={(text) => {
                    setItem((val) => ({
                      ...val,
                      theme: { ...val.theme, header: text },
                    }));
                  }}
                  value={items.theme.header}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: "#fff",
                      padding: 5,
                      borderRadius: 5,
                      borderWidth: 0.5,
                      borderColor: "#555",
                      color: "#555",
                      marginHorizontal: 5,
                      fontSize: 12,
                      fontFamily: "Prompt-Regular",
                      paddingHorizontal: 5,
                    },
                  ]}
                />
              </View>

              <View style={styles.Boxarea}>
                <Text style={[styles.Text20, { width: width * 0.1 }]}>
                  ปุ่ม
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    // setstate1(!state1);
                    statecolor1();
                  }}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: items.theme.button,
                      marginHorizontal: 10,
                    },
                  ]}
                />
                {state1 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setItem((val) => ({
                        ...val,
                        theme: { ...val.theme, button: text },
                      }));
                    }}
                    color={items.theme.button}
                  />
                )}
                <TextInput
                  onChangeText={(text) => {
                    setItem((val) => ({
                      ...val,
                      theme: { ...val.theme, button: text },
                    }));
                  }}
                  value={items.theme.button}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: "#fff",
                      padding: 5,
                      borderRadius: 5,
                      borderWidth: 0.5,
                      borderColor: "#555",
                      color: "#555",
                      marginHorizontal: 5,
                      fontSize: 12,
                      fontFamily: "Prompt-Regular",
                      paddingHorizontal: 5,
                    },
                  ]}
                />
              </View>
            </View>

            <View
              style={{
                width: width * 0.6,
                flexDirection: "row",
                marginVertical: 15,
                height: height * 0.15,
              }}
            >
              <View style={styles.Boxarea}>
                <Text style={[styles.Text20, { width: width * 0.12 }]}>
                  ข้อความ active
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    statecolor2();
                  }}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: items.theme.text,
                      marginHorizontal: 10,
                    },
                  ]}
                />

                {state2 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setItem((val) => ({
                        ...val,
                        theme: { ...val.theme, text: text },
                      }));
                    }}
                    color={items.theme.text}
                  />
                )}
                <TextInput
                  onChangeText={(text) => {
                    setItem((val) => ({
                      ...val,
                      theme: { ...val.theme, text: text },
                    }));
                  }}
                  value={items.theme.text}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: "#fff",
                      padding: 5,
                      borderRadius: 5,
                      borderWidth: 0.5,
                      borderColor: "#555",
                      color: "#555",
                      marginHorizontal: 5,
                      fontSize: 12,
                      fontFamily: "Prompt-Regular",
                      paddingHorizontal: 5,
                    },
                  ]}
                />
              </View>

              <View style={styles.Boxarea}>
                <Text style={[styles.Text20, { width: width * 0.1 }]}>
                  ปฏิทิน
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    statecolor4();
                  }}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: items.theme.calender,
                      marginHorizontal: 10,
                    },
                  ]}
                />

                {state4 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setItem((val) => ({
                        ...val,
                        theme: { ...val.theme, calender: text },
                      }));
                    }}
                    color={items.theme.calender}
                  />
                )}
                <TextInput
                  onChangeText={(text) => {
                    setItem((val) => ({
                      ...val,
                      theme: { ...val.theme, calender: text },
                    }));
                  }}
                  value={items.theme.calender}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: "#fff",
                      padding: 5,
                      borderRadius: 5,
                      borderWidth: 0.5,
                      borderColor: "#555",
                      color: "#555",
                      marginHorizontal: 5,
                      fontSize: 12,
                      fontFamily: "Prompt-Regular",
                      paddingHorizontal: 5,
                    },
                  ]}
                />
                {/* {state4 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setItem((val) => ({
                        ...val,
                        theme: { ...val.theme, calender: text },
                      }));
                    }}
                    color={items.theme.calender}
                  />
                )}
                <TextInput
                  onChangeText={(text) => {
                    setItem((val) => ({
                      ...val,
                      theme: { ...val.theme, calender: text },
                    }));
                  }}
                  value={items.theme.calender}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: "#fff",
                      padding: 5,
                      borderRadius: 5,
                      borderWidth: 0.5,
                      borderColor: "#555",
                      color: "#555",
                      marginHorizontal: 5,
                      fontSize: 12,
                      fontFamily: "Prompt-Regular",
                      paddingHorizontal: 5,
                    },
                  ]}
                /> */}
              </View>

              {/* <View style={styles.Boxarea}>
                <Text style={[styles.Text20, { width: width * 0.12 }]}>
                  ไอคอน active
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    statecolor3();
                  }}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: items.theme.text,
                      marginHorizontal: 10,
                    },
                  ]}
                />
                {state3 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setItem((val) => ({
                        ...val,
                        theme: { ...val.theme, icon: text },
                      }));
                    }}
                    color={items.theme.text}
                  />
                )}
                <TextInput
                  onChangeText={(text) => {
                    setItem((val) => ({
                      ...val,
                      theme: { ...val.theme, icon: text },
                    }));
                  }}
                  value={items.theme.text}
                  style={[
                    styles.colorChange,
                    {
                      backgroundColor: "#fff",
                      padding: 5,
                      borderRadius: 5,
                      borderWidth: 0.5,
                      borderColor: "#555",
                      color: "#555",
                      marginHorizontal: 5,
                      fontSize: 12,
                      fontFamily: "Prompt-Regular",
                      paddingHorizontal: 5,
                    },
                  ]}
                />
              </View> */}
            </View>

            {/* <View
              style={{
                width: width * 0.6,
                flexDirection: "row",
                marginVertical: 15,
              }}
            >
              <View style={styles.Boxarea}>
                <Text style={[styles.Text20, { width: width * 0.1 }]}>
                  ข้อความ active
                </Text>
                {state2 == false && (
                  <TouchableOpacity
                    onPress={() => {
                      statecolor2();
                    }}
                    style={[
                      styles.viewColor,
                      { backgroundColor: color2, marginHorizontal: 10 },
                    ]}
                  />
                )}

                {state2 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setColor2(text);
                    }}
                    color={color2}
                  />
                )}
              </View>
              
              <View style={styles.Boxarea}>
                <Text style={[styles.Text20]}>ไอคอน active</Text>

                {state3 == false && (
                  <TouchableOpacity
                    onPress={() => {
                      setstate3(!state3);
                    }}
                    style={[styles.colorChange, { backgroundColor: color3 }]}
                  />
                )}
                {state3 == true && (
                  <TouchableOpacity
                    onPress={() => {
                      setstate3(!state3);
                    }}
                    style={[styles.colorChange, { backgroundColor: color3 }]}
                  />
                )}
                {state3 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setColor3(text);
                    }}
                    color={color3}
                  />
                )}
              </View>
            </View> */}

            {/* 
            <View
              style={{
                width: width * 0.6,
                height: height * 0.037,
                flexDirection: "row",
                justifyContent: "space-between",
                marginVertical: 15,
              }}
            >
              <View style={styles.Boxarea}>
                <Text style={styles.Text20}>ปฏิทิน</Text>
                {state4 == false && (
                  <TouchableOpacity
                    onPress={() => {
                      setstate4(!state4);
                    }}
                    style={[styles.colorChange, { backgroundColor: color4 }]}
                  />
                )}
                {state4 == true && (
                  <TouchableOpacity
                    onPress={() => {
                      setstate4(!state4);
                    }}
                    style={[styles.colorChange, { backgroundColor: color4 }]}
                  />
                )}

                {state4 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setColor4(text);
                    }}
                    color={color4}
                  />
                )}
              </View>
              <View style={styles.Boxarea}>
                <Text style={styles.Text20}>หัวข้อ/ไอคอนหน้าโปรไฟล์</Text>
                {state5 == false && (
                  <TouchableOpacity
                    onPress={() => {
                      setstate5(!state5);
                    }}
                    style={[styles.colorChange, { backgroundColor: color5 }]}
                  />
                )}
                {state5 == true && (
                  <TouchableOpacity
                    onPress={() => {
                      setstate5(!state5);
                    }}
                    style={[styles.colorChange, { backgroundColor: color5 }]}
                  />
                )}

                {state5 == true && (
                  <HexColorPicker
                    onChange={(text) => {
                      setColor4(text);
                    }}
                    color={color5}
                  />
                )}
              </View>
            </View> */}

            {/* {bankList.map((data, index) => (
              <TouchableOpacity
                key={data}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginLeft: 40,
                }}
                onPress={bankChangeHandler.bind(this, index, data)}
              >
                <MaterialCommunityIcons
                  name={
                    index === bankIndex
                      ? "checkbox-marked"
                      : "checkbox-blank-outline"
                  }
                  size={30}
                  color="#BBBBBB"
                />
                <Text
                  style={[
                    width < 1600
                      ? stylesResponsive.textDetail
                      : styles.textDetail,
                  ]}
                >
                  {data}
                </Text>
              </TouchableOpacity>
            ))} */}
            <View
              style={{
                flexDirection: "row",
                marginTop: 15,
                width: width * 0.6,
                alignSelf: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  color: "black",
                  fontFamily: "Prompt-Regular",
                  padding: 10,
                }}
              >
                ชื่อ
              </Text>
              <TextInput
                defaultValue={items.name}
                style={{
                  width: 200,
                  height: 50,
                  borderRadius: 10,
                  borderWidth: 0.4,
                  padding: 5,
                  fontFamily: "Prompt-Regular",
                }}
                onChangeText={(text) => {
                  setItem((val) => ({ ...val, name: text }));
                }}
              />
            </View>
            {token.role == "SUPERADMIN" && (
              <View style={{ width: width * 0.6, marginTop: 20 }}>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: "Prompt-Regular",
                    marginVertical: 10,
                  }}
                >
                  logo
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const res = await addImage();
                    setItem((val) => ({ ...val, logo: res }));
                  }}
                  style={{
                    width: width * 0.05,
                    height: height * 0.037,
                    backgroundColor: "#002377",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: "Prompt-Regular",
                      color: "#ffff",
                      margin: "auto",
                    }}
                  >
                    อัพโหลดรูป
                  </Text>
                </TouchableOpacity>
                <View
                  style={{
                    width: width * 0.05,
                    height: width * 0.05,
                    backgroundColor: "#002377",
                    marginTop: 15,
                  }}
                >
                  <Image
                    style={{
                      width: width * 0.05,
                      height: width * 0.05,
                    }}
                    source={{ uri: items.logo }}
                  />
                </View>
              </View>
            )}
            <View style={styles.boxAreaButton}>
              <TouchableOpacity
                onPress={onPress}
                style={{
                  width: 100,
                  height: 40,
                  borderRadius: 5,
                  backgroundColor: "#69D443",
                  marginRight: 20,
                }}
              >
                <Text style={styles.TextButton}>ยืนยัน</Text>
              </TouchableOpacity>
              {token.role == "SUPERADMIN" && (
                <TouchableOpacity
                  onPress={() => {
                    // if (token.role == "SUPERADMIN") {  }
                    setpage(1);
                  }}
                  style={{
                    width: 100,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#D44343",
                  }}
                >
                  <Text style={styles.TextButton}>ยกเลิก</Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </View>
      )}
      {page == 1 && <ManageApplications />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Boxarea: {
    width: width * 0.38,
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 20,
  },
  Text20: { fontSize: 16, fontFamily: "Prompt-Regular" },

  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  boxAreaButton: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    marginTop: 30,
  },
  viewColor: {
    width: width * 0.045,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
  },
  colorChange: {
    width: width * 0.045,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
  },
});

export default manageThemes;
